module.exports = __webpack_public_path__ + "static/media/mobile_lane_closure.98284010.png";